import { ApiResponse, TokenData, ChangeLeadAssigneeReason } from '../models';
import * as http from './http';
import ApiService from './service';

export class ChangeLeadAssigneeUserReasonService extends ApiService {

    public async loadAllChangeLeadAssigneeRejectReason(data: any) {
        const url = `${this.apiDomain}/api/reasons/list`;

        const resposne = await http.post<ApiResponse<ChangeLeadAssigneeReason[]>>(
            url,
            data,
            this.store
        );
        return resposne?.data?.data;
    }
    public async updateChangeLeadAssigneeRejectReason(data: any, id?: string) {
        const url = `${this.apiDomain}/api/reasons/${id}`;

        const response = await http.put<ApiResponse<TokenData>>(
            url,
            data,
            this.store
        );
        return response.data;
    }

    public async createChangeLeadAssigneeRejectReason(data: any, id?: string) {
        const url = `${this.apiDomain}/api/reasons`;

        const response = await http.post<ApiResponse<TokenData>>(
            url,
            data,
            this.store
        );
        return response.data;
    }

    public async deleteChangeLeadAssigneeRejectReason(id?: string) {
        const url = `${this.apiDomain}/api/reasons/${id}`;

        const response = await http.remove<ApiResponse<any>>(
            url,
            this.store
        );
        return response.data;
    }

}
